// routes.js
import { lazy } from 'react';

import { ALL_MENU_DATA } from 'routers/routes.data';

/**
 * React Lazy 컴포넌트 매핑
 * @type {Object.<string, React.LazyExoticComponent>}
 */
export const COMPONENTS = {
  // 메인
  MainPage: lazy(() => import('pages/main/MainPage')),

  // 소개
  IntroPage: lazy(() => import('pages/introduce/IntroPage')),
  BizPartnerPage: lazy(() => import('pages/introduce/BizPartnerPage')),
  BizServicePage: lazy(() => import('pages/introduce/BizServicePage')),

  // 요금제
  BillingPlanPage: lazy(() => import('pages/billing/BillingPlanPage')),
  BillingPlanInfoTypePage: lazy(
    () => import('pages/billing/BillingPlanInfoTypePage')
  ),
  BillingPlanTypePage: lazy(() => import('pages/billing/BillingPlanTypePage')),
  BillingPlanCalcPage: lazy(() => import('pages/billing/BillingPlanCalcPage')),

  // 기능 소개
  FeatureGuidePage: lazy(() => import('pages/guide/FeatureGuidePage')),
  StartGuidePage: lazy(() => import('pages/guide/StartGuidePage')),
  GuidePage: lazy(() => import('pages/map/GuidePage')),
  WizardPage: lazy(() => import('pages/map/WizardPage')),
  MwsLanguagePage: lazy(() => import('pages/mw_sample/mws_map/MwsLanguagePage')),
  WebStaticMaps: lazy(
    () => import('pages/web_sample/ws_static/WsStaticMapPage')
  ),
  // 지도 (MW)
  MwsMapCreatePage: lazy(
    () => import('pages/mw_sample/mws_map/MwsMapCreatePage')
  ),
  MwsMapStylePage: lazy(
    () => import('pages/mw_sample/mws_map/MwsMapStylePage')
  ),
  MwsMapEventPage: lazy(
    () => import('pages/mw_sample/mws_map/MwsMapEventPage')
  ),
  MwsMapFlyToPage: lazy(
    () => import('pages/mw_sample/mws_map/MwsMapFlyToPage')
  ),
  MwsMapInteractionControlPage: lazy(
    () => import('pages/mw_sample/mws_map/MwsMapInteractionControlPage')
  ),
  MwsMapControlPage: lazy(
    () => import('pages/mw_sample/mws_map/MwsMapControlPage')
  ),
  MwsMapCalcBetweenTwoPointPage: lazy(
    () => import('pages/mw_sample/mws_map/MwsMapCalcBetweenTwoPointPage')
  ),
  MwsInformationPage: lazy(
    () => import('pages/mw_sample/mws_map/MwsInformationPage')
  ),
  MwsMapTypePage: lazy(() => import('pages/mw_sample/mws_map/MwsMapTypePage')),

  // 마커
  MwsMarkerCreatePage: lazy(
    () => import('pages/mw_sample/mws_marker/MwsMarkerCreatePage')
  ),
  MwsMarkerMovePage: lazy(
    () => import('pages/mw_sample/mws_marker/MwsMarkerMovePage')
  ),
  MwsMarkerEventPage: lazy(
    () => import('pages/mw_sample/mws_marker/MwsMarkerEventPage')
  ),
  MwsMarkerOverlappingPage: lazy(
    () => import('pages/mw_sample/mws_marker/MwsMarkerOverlappingPage')
  ),
  MwsMarkerConnectLocationPage: lazy(
    () => import('pages/mw_sample/mws_marker/MwsMarkerConnectLocationPage')
  ),
  MwsMarkerAnimation: lazy(
    () => import('pages/mw_sample/mws_marker/MwsMarkerAnimation')
  ),
  MwsMarkerStylePage: lazy(
    () => import('pages/mw_sample/mws_marker/MwsMarkerStylePage')
  ),
  MwsMarkerClusterCreatePage: lazy(
    () => import('pages/mw_sample/mws_marker/MwsMarkerClusterCreatePage')
  ),
  MwsMarkerClusterSettingDistancePage: lazy(
    () =>
      import('pages/mw_sample/mws_marker/MwsMarkerClusterSettingDistancePage')
  ),
  MwsMarkerClusterEventPage: lazy(
    () => import('pages/mw_sample/mws_marker/MwsMarkerClusterEventPage')
  ),

  // 피처
  MwsFeatureCreatePage: lazy(
    () => import('pages/mw_sample/mws_feature/MwsFeatureCreatePage')
  ),
  MwsFeatureInteractionPage: lazy(
    () => import('pages/mw_sample/mws_feature/MwsFeatureInteractionPage')
  ),
  MwsFeatureAddEventPage: lazy(
    () => import('pages/mw_sample/mws_feature/MwsFeatureAddEventPage')
  ),
  MwsFeatureStylePage: lazy(
    () => import('pages/mw_sample/mws_feature/MwsFeatureStylePage')
  ),
  MwsFeatureRadiusPage: lazy(
    () => import('pages/mw_sample/mws_feature/MwsFeatureRadiusPage')
  ),
  MwsFeatureCustomLabelPage: lazy(
    () => import('pages/mw_sample/mws_feature/MwsFeatureCustomLabelPage')
  ),
  MwsFeatureMoveLabelPage: lazy(
    () => import('pages/mw_sample/mws_feature/MwsFeatureMoveLabelPage')
  ),
  MwsFeatureCalcPage: lazy(
    () => import('pages/mw_sample/mws_feature/MwsFeatureCalcPage')
  ),

  // 데이터
  MwsDataGeoCodingPage: lazy(
    () => import('pages/mw_sample/mws_data/MwsDataGeoCodingPage')
  ),
  MwsDataReverseGeoCodingPage: lazy(
    () => import('pages/mw_sample/mws_data/MwsDataReverseGeoCodingPage')
  ),
  MwsDataCreatePathPage: lazy(
    () => import('pages/mw_sample/mws_data/MwsDataCreatePathPage')
  ),
  MwsDataSearchPoiPage: lazy(
    () => import('pages/mw_sample/mws_data/MwsDataSearchPoiPage')
  ),

  // 팝업
  MwsInfoWindowCreatePage: lazy(
    () => import('pages/mw_sample/mws_infowindow/MwsInfoWindowCreatePage')
  ),
  MwsInfoWindowContentsPage: lazy(
    () => import('pages/mw_sample/mws_infowindow/MwsInfoWindowContentsPage')
  ),
  MwsInfoWindowCustomPage: lazy(
    () => import('pages/mw_sample/mws_infowindow/MwsInfoWindowCustomPage')
  ),

  // 검색
  ResultCodePage: lazy(() => import('pages/web_sample/ResultCodePage')),

  // 검색
  WsWebGeoCodingPage: lazy(
    () => import('pages/web_sample/ws_search/WsWebGeoCodingPage')
  ),
  WsWebReverseGeoCodingPage: lazy(
    () => import('pages/web_sample/ws_search/WsWebReverseGeoCodingPage')
  ),
  WsWebIntegratedSearchPage: lazy(
    () => import('pages/web_sample/ws_search/WsWebIntegratedSearchPage')
  ),
  WsWebPoiDetailSearchPage: lazy(
    () => import('pages/web_sample/ws_search/WsWebPoiDetailSearchPage')
  ),
  WsWebSubPoiDetailSearchPage: lazy(
    () => import('pages/web_sample/ws_search/WsWebSubPoiDetailSearchPage')
  ),
  WsWebPoiCategorySearchPage: lazy(
    () => import('pages/web_sample/ws_search/WsWebPoiCategorySearchPage')
  ),
  WsWebProposersSearchPage: lazy(
    () => import('pages/web_sample/ws_search/WsWebProposersSearchPage')
  ),
  WsWebAdminToPolygonPage: lazy(
    () => import('pages/web_sample/ws_search/WsWebAdminToPolygonPage')
  ),
  WsWebPolygonToAdminPage: lazy(
    () => import('pages/web_sample/ws_search/WsWebPolygonToAdminPage')
  ),
  WsWebTransCoordinatePage: lazy(
    () => import('pages/web_sample/ws_search/WsWebTransCoordinatePage')
  ),
  WsWebSearchEntryPointPage: lazy(
    () => import('pages/web_sample/ws_search/WsWebSearchEntryPointPage')
  ),
  WsW3WProposersSeacrchPage: lazy(
    () => import('pages/web_sample/ws_search/WsW3WProposersSeacrchPage')
  ),
  WsW3WReverseGeocodingPage: lazy(
    () => import('pages/web_sample/ws_search/WsW3WReverseGeoCodingPage')
  ),
  WsW3WOptPositionSearchesPage: lazy(
    () => import('pages/web_sample/ws_search/WsW3WOptPositionSearchesPage')
  ),
  WsWebOptimalPositionSearches: lazy(
    () => import('pages/web_sample/ws_search/WsWebOptimalPositionSearches')
  ),
  WsWebGlobalIntegratedSearchPage: lazy(
    () => import('pages/web_sample/ws_search/WsWebGlobalIntegratedSearchPage')
  ),

  // 탐색
  WsWebRouteNormalPage: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteNormalPage')
  ),
  WsWebRouteSummaryPage: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteSummaryPage')
  ),
  WsWebRouteMultiplePage: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteMultiplePage')
  ),
  WsWebRouteMultipleStartPage: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteMultipleStartPage')
  ),
  WsWebRouteMultipleEndPage: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteMultipleEndPage')
  ),
  WsWebRouteTimePage: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteTimePage')
  ),
  WsWebRouteRoadMatchPage: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteRoadMatchPage')
  ),
  WsWebRouteDistanceMatrixPage: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteDistanceMatrixPage')
  ),
  WsWebRouteMatchToRoadPage: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteMatchToRoadPage')
  ),
  WsWebRouteMatchToRoad1000Page: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteMatchToRoad1000Page')
  ),
  WsWebRoutePedestrianPage: lazy(
    () => import('pages/web_sample/ws_route/WsWebRoutePedestrianPage')
  ),
  WsWebRouteOptimizePoints10Page: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteOptimizePoints10Page')
  ),
  WsWebRouteOptimizePoints30Page: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteOptimizePoints30Page')
  ),
  WsWebRouteOptimizePoints50Page: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteOptimizePoints50Page')
  ),
  WsWebRouteOptimizePoints100Page: lazy(
    () => import('pages/web_sample/ws_route/WsWebRouteOptimizePoints100Page')
  ),

  // HIDDEN
  WsElevationSearchPage: lazy(
    () => import('pages/web_sample/ws_search/WsElevationSearchPage')
  ),
  WsMultiElevationSearchPage: lazy(
    () => import('pages/web_sample/ws_search/WsMultiElevationSearchPage')
  ),
  WsDivideElevationSearchPage: lazy(
    () => import('pages/web_sample/ws_search/WsDivideElevationSearchPage')
  ),

  // 스튜디오
  WebMapStudioPage: lazy(
    () => import('pages/web_sample/ws_studio/WebMapStudioPage')
  ),
  WebIntroStudioPage: lazy(
    () => import('pages/web_sample/ws_studio/WebIntroStudioPage')
  ),

  // 솔루션 소개
  SolutionIntroPage: lazy(() => import('pages/solution/SolutionIntroPage')),

  // 물류 최적화 솔루션
  OptimizationSolutionPage: lazy(
    () => import('pages/solution/OptimizationSolutionPage')
  ),

  // 공지사항
  NoticePage: lazy(() => import('pages/notice/NoticePage')),
  NoticeDetailPage: lazy(() => import('pages/notice/NoticeDetailPage')),

  // PRESS & MEDIA
  PressMediaPage: lazy(() => import('pages/pressmedia/PressMediaPage')),

  // 개발문의
  DevCommunityPage: lazy(
    () => import('pages/community/developer/DevCommunityPage')
  ),
  DevCommunityDetailPage: lazy(
    () => import('pages/community/developer/DevCommunityDetailPage')
  ),
  DevCommunityFormPage: lazy(
    () => import('pages/community/developer/DevCommunityFormPage')
  ),

  // FAQ
  FaQPage: lazy(() => import('pages/community/faq/FaQPage')),

  // 1:1 문의
  BusinessPage: lazy(() => import('pages/community/business/BusinessPage')),

  // 대시보드
  DashBoardPage: lazy(() => import('pages/console/DashBoardPage')),

  // APP
  AppPage: lazy(() => import('pages/console/app/AppPage')),
  AppDetailPage: lazy(() => import('pages/console/app/AppDetailPage')),

  // 요금 조회
  BillingQueryPage: lazy(
    () => import('pages/console/billingquery/BillingQueryPage')
  ),
  BillingQueryDetailPage: lazy(
    () => import('pages/console/billingquery/BillingQueryDetailPage')
  ),

  // 이용 상품 관리
  ProductManagementPage: lazy(
    () => import('pages/console/billingquery/ProductManagementPage')
  ),

  // 카드 관리
  CardManagementPage: lazy(
    () => import('pages/console/billingquery/CardManagementPage')
  ),

  // 회원 정보
  UserInfoPage: lazy(() => import('pages/console/userInfo/UserInfoPage')),
  UserInfoModifyPage: lazy(
    () => import('pages/console/userInfo/UserInfoModifyPage')
  ),
  UserInfoBizChangePage: lazy(
    () => import('pages/console/userInfo/UserInfoBizChangePage')
  ),
  UserInfoWithdrawalPage: lazy(
    () => import('pages/console/userInfo/UserInfoWithdrawalPage')
  ),

  // 회원 가입
  SignUpPage: lazy(() => import('pages/signup/SignUpPage')),
  SignUpTypePage: lazy(() => import('pages/signup/SignUpTypePage')),
  SignUpFormPage: lazy(() => import('pages/signup/SignUpFormPage')),
  SignUpSuccessPage: lazy(() => import('pages/signup/SignUpSuccessPage')),

  // 인증
  AuthPage: lazy(() => import('pages/auth/AuthPage')),

  // mcp 서버
  McpIntroPage: lazy(() => import('pages/mcp/McpIntroPage')),
  McpGuidePage: lazy(() => import('pages/mcp/McpGuidePage')),
};

const generateRoutes = (data) => {
  const routes = {};

  // 모든 JSON의 'pages' 객체를 순회
  data.forEach((item) => {
    if (item && item.pages) {
      Object.entries(item.pages).forEach(([key, page]) => {
        if (page.path && page.component) {
          routes[key] = {
            ...page,
            // key를 보존하고 싶은 경우를 대비해 key도 포함할 수 있음
            key: key,
          };
        }
      });
    }
  });

  return routes;
};

/**
 * 통합된 라우트 데이터
 * @type {Object}
 */
export const ROUTE_DATA = generateRoutes(ALL_MENU_DATA);
